import { Component } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { faCircleExclamation } from '@fortawesome/free-solid-svg-icons';
import { ButtonComponent } from '@shared/components/button';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@Component({
  selector: 'app-reopen-application-modal',
  templateUrl: 'reopen-application-modal.component.html',
  imports: [FaIconComponent, ButtonComponent, MatButtonModule, MatDialogModule],
})
export class ReopenApplicationModalComponent {
  protected readonly faCircleExclamation = faCircleExclamation;
}
